import { render, staticRenderFns } from "./RedPaper.vue?vue&type=template&id=444be020&scoped=true"
import script from "./RedPaper.vue?vue&type=script&lang=js"
export * from "./RedPaper.vue?vue&type=script&lang=js"
import style0 from "./RedPaper.vue?vue&type=style&index=0&id=444be020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444be020",
  null
  
)

export default component.exports